import React from 'react';
interface HorseshoeIconProps {
  className?: string;
}
const horseshoeUrl = 'url(https://cdn.magicpatterns.com/uploads/cuoqFLRDvPbgtGnkde57h4/horseshoe-icon.svg)';

// The SVG is used as a mask so the icon takes the text colour (text-saddle, text-hay…).
export function HorseshoeIcon({
  className
}: HorseshoeIconProps) {
  return <span aria-hidden="true" className={`inline-block shrink-0 rotate-180 ${className ?? ''}`} style={{
    backgroundColor: 'currentColor',
    WebkitMaskImage: horseshoeUrl,
    maskImage: horseshoeUrl,
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center'
  }} data-id="element-197" data-mp="1ldd1hqkrfi1q" />;
}